// extracted by mini-css-extract-plugin
export var footer = "page-layout-module--footer--4f2a1";
export var footerContainer = "page-layout-module--footer-container--74d7c";
export var header = "page-layout-module--header--09b8b";
export var headerContainer = "page-layout-module--header-container--3cc00";
export var main = "page-layout-module--main--ad828";
export var mainContainer = "page-layout-module--main-container--8e94a";
export var pageTitle = "page-layout-module--page-title--0cd45";